var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "243px",
    height: "243px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 29,
    width: 15,
    height: 42,
    fill: "#0bb7a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "16.4;29;29",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "67.2;42;42",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 29,
    width: 15,
    height: 42,
    fill: "#0bb7a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "19.549999999999997;29;29",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "60.900000000000006;42;42",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.1s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 29,
    width: 15,
    height: 42,
    fill: "#0bb7a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "19.549999999999997;29;29",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "60.900000000000006;42;42",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.baf0a1a9e3b70c2b601e2938c4a194ec.svg";
export { ForwardRef as ReactComponent };